export default __webpack_public_path__ + "static/media/livingroom.940afe91.jpg";